module.exports = __webpack_public_path__ + "img/gp-day.748157d2.png";